/**
 * Verfassung — nur frische Geist/Seele-Werte gelten als „jetzt“.
 */

interface MoodKurz {
  day: string;
  geist: number | null;
  seele: number | null;
  einzeiler?: string | null;
}

type VerfassungLabel = "Körper" | "Geist" | "Seele";

interface VerfassungZeile {
  label: VerfassungLabel;
  wert: number;
}

export function wienTag(d = new Date()): string {
  return d.toLocaleDateString("en-CA", { timeZone: "Europe/Vienna" });
}

/** Heute oder gestern (Wien), sonst veraltet. */
export function istMoodFrisch(day: string, heute: string): boolean {
  if (day === heute) return true;
  const t = Date.parse(`${heute}T12:00:00Z`);
  if (!Number.isFinite(t)) return false;
  const gestern = new Date(t - 86_400_000).toISOString().slice(0, 10);
  return day === gestern;
}

export function juengsteFrischeMood(
  moods: MoodKurz[],
  heute: string,
): MoodKurz | null {
  return (
    moods.find(
      (m) =>
        istMoodFrisch(m.day, heute) && (m.geist != null || m.seele != null),
    ) ?? null
  );
}

/** Nur Zeilen mit echter Zahl — kein „–“, kein Platzhalter. */
export function sichtbareTrioZeilen(src: {
  koerper: number | null | undefined;
  geist: number | null | undefined;
  seele: number | null | undefined;
}): VerfassungZeile[] {
  const out: VerfassungZeile[] = [];
  if (src.koerper != null) out.push({ label: "Körper", wert: src.koerper });
  if (src.geist != null) out.push({ label: "Geist", wert: src.geist });
  if (src.seele != null) out.push({ label: "Seele", wert: src.seele });
  return out;
}

/**
 * Der Trio-Kasten nur, wenn Geist oder Seele eine echte Zahl haben.
 * Körper allein lebt im WHOOP-Ring — sonst sähe eine einzelne Zeile
 * nach Formular mit fehlenden Geschwistern aus.
 */
export function trioHatInnereQuelle(zeilen: VerfassungZeile[]): boolean {
  return zeilen.some((z) => z.label === "Geist" || z.label === "Seele");
}
